export const TOOL_TASK = 'update-lcd-credit-analysis-subscription';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once current task is completed';
export const FILE_HEADERS = {
    userId: 'User Id',
    userEmail: 'Email',
    actionStatus: 'Action Status',
};

export const TOOL_PROGRESS_LABEL = 'Bulk updating of LCD Credit Analysis subscription progress...';

export const LCS_SUBSCRIPTION_TITLES = {
    SUBSCRIBE: 'Subscribe to LCD Credit Analysis',
    UNSUBSCRIBE: 'Unsubscribe from LCD Credit Analysis',
};

export const LCD_SUBSCRIPTION_MODAL_WIDTH = 680;
